import { useEffect } from "react";

// A route that has moved off this app. replace(), not assign(), so Back skips
// the dead path instead of bouncing straight forward again.
const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};

export default ExternalRedirect;
